import Image from 'next/image';
import { Box, Heading } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';
import { GridLayout } from '@99designs/marketing-ui';
import { ReasonsWrapper } from '../../ReasonsWrapper/ReasonsWrapper';
import { getVPReasons } from './getVPReasons';

type WhyVPSectionProps = {
    title: string;
    image: string;
};

export const WhyVPSection = ({ title, image }: WhyVPSectionProps) => {
    const reasons = getVPReasons();

    return (
        <GridLayout>
            <Box
                background={colors.white}
                display="flex"
                flexDirection={['column-reverse', 'column-reverse', 'column-reverse', 'row']}
                paddingY={['3bu', '3bu', '4bu', '6bu']}
            >
                <Box
                    width={['inherit', 'inherit', 'inherit', '40%']}
                    display="flex"
                    flexDirection="column"
                    alignItems={['center', 'center', 'center', 'start']}
                >
                    <Box
                        position="relative"
                        height={['270px', '450px', '450px', '450px']}
                        width={['262.8px', '438px', '438px', '438px']}
                        display="block"
                    >
                        <Image
                            src={'/images/vp-product-landing/whyVP/whyVP.webp'}
                            alt=""
                            role="presentation"
                            objectFit="contain"
                            layout="fill"
                            quality={75}
                        />
                    </Box>
                </Box>
                <Box
                    width={['inherit', 'inherit', 'inherit', '60%']}
                    paddingLeft={['none', 'none', 'none', '2bu']}
                >
                    <Heading accessibilityLevel={2} appearanceLevel={3}>
                        {title}
                    </Heading>
                    <ReasonsWrapper reasons={reasons} />
                </Box>
            </Box>
        </GridLayout>
    );
};
